import React, { useRef, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import backIcon from '../../assets/back.png'; // Adjust the path as necessary
import menuIcon from '../../assets/menu.png';
import openBot from '../../assets/open_bot.png';
import reloadPage from '../../assets/reload_page.png';
import termsOfUse from '../../assets/terms_of_use.png';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dropdownRef = useRef(null);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
    };

    if (dropdownVisible) {
      document.addEventListener('mousedown', handleOutsideClick);
    } else {
      document.removeEventListener('mousedown', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [dropdownVisible, setDropdownVisible]);

  const goBack = () => {
    if(location.pathname === "/joinclan") navigate('/');
    else navigate('/joinclan');
  };

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  return (
    <div className="header">
      {
        location.pathname.includes("joinclan") || location.pathname.includes("joinClan") ? <div className="back-button" onClick={goBack}>
         <img src={backIcon} alt="Back" />
      </div> : location.pathname.includes("levels")? <div className="back-button" onClick={()=>{
        navigate('/');
      }}>
         <img src={backIcon} alt="Back" />
      </div> : ""
      }
      <div className="title"></div>
      <div className="menu">
        {/* <img src={menuIcon} alt="Menu" /> */}
      </div>
      {/* {dropdownVisible && (
        <div ref={dropdownRef} className="dropdown-menu">
          <button onClick={handleClickOpenBot}>
            <img src={openBot} alt="Open Bot" />
            Open Bot
          </button>
          <button onClick={handleReloadPage}>
            <img src={reloadPage} alt="Reload Page" />
            Reload Page
          </button>
        </div>
      )} */}
    </div>
  );
};

export default Header;
